import { Directive, EventEmitter, HostListener, Output } from "@angular/core";

@Directive({
    selector: '[dnd]'
})
export class DndDirective {
    @Output()
    public fileDropped = new EventEmitter<FileList>()

    @HostListener('dragover', ['$event'])
    onDragOver(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        console.log('dragover event', {event})
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        console.log('dragleave event', {event})
    }

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const files = event.dataTransfer.files

        if(files.length > 0) {
            this.fileDropped.emit(files);
        }
        console.log('drop event', {event, files})
    }
}